import dayjs from 'dayjs';
import {FormikValues} from 'formik';
import {toast} from 'react-toastify';
import { ICurrentUserState, IDateTimeOrdersState,  IRetrieveOrder,  ITariff,  TLabelAndValue,  TStockCheckDataSerializerStaff,  TUserOrderParticipants } from '@/types';
import { api } from '@/api';
import { objectKeys } from '@/utils';
import {checkManualStockStaff} from '../../../../../components/ManualStock/helpers';
import {
    NAME_STATUS_API_ORDER,
    PAYMENT_TYPE,
    TYPE_USER_SPORTSMAN,
    TYPES_STATUS
} from '../../../consts';
import {convertTimeToIntegerMinutes, rangeMultiOrdersOptions, rangeOptions} from '../../../helpers';
import {ORDERS, TYPE_USER, TYPES_DEPOSITS} from '../../../../../const';
import {IReturnOrders} from '../interfaces';
import {TYPES} from '../../ModalPayCertificateOrDeposit/const';
import {RETURN_PAY_TYPES} from '../const';

// eslint-disable-next-line consistent-return
export const checkAutomaticStockOrder = async (formik: any, date: string | null | undefined, currentUser: ICurrentUserState, setAutomaticFlag?: (e: boolean) => void) => {
    try {
        const results = await api.tariff.checkAutomaticStock({
            user_id: formik.values.customer.value,
            data: [{
                tariff_rate: formik.values.tariff_rate.id,
                start_at: dayjs(date, 'YYYY.MM.DD HH:mm').subtract(3, 'h').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
                price: currentUser.user_status === TYPE_USER.SUPERUSER ? formik.values.base_price : undefined
            }]
        });

        if (setAutomaticFlag) setAutomaticFlag(results[0].code);

        if (results[0].code) {
            formik.setFieldValue('is_automatic_stock', results[0].code);
            formik.setFieldValue('price_stock', results[0].full_discount);
            formik.setFieldValue('stock', results[0].stock_id);
            formik.setFieldValue('stock_name', results[0].stock_name);
            formik.setFieldValue('manual_stock', null);
            formik.setFieldValue('promo_code', null);
        } else {
            formik.setFieldValue('is_automatic_stock', results[0].code);
            formik.setFieldValue('price_stock', results[0].full_discount);
            formik.setFieldValue('stock_name', null);
        }
        return results[0];
    } catch (e) {
        console.error(e);
        formik.setFieldValue('stock_name', null);
        formik.setFieldValue('price_stock', null);
        if (setAutomaticFlag) setAutomaticFlag(false);
        return {
            code: false
        };
    }
};

export const checkManualStockOrder = async (formik: any, item: TLabelAndValue, currentUser: ICurrentUserState, activeHeaderItem?: number) => {
    try {
        const results = await checkManualStockStaff({
            user_id: formik.values.customer.value,
            stock_id: item.value.toString(),
            data: [
                {
                    price: currentUser.user_status === TYPE_USER.SUPERUSER ? formik.values.base_price : undefined,
                    tariff_rate: activeHeaderItem === TYPES.CERTIFICATES ? undefined : formik.values.tariff_rate.id,
                    certificate_generator: activeHeaderItem === TYPES.CERTIFICATES ? formik.values.tariff_rate.id : undefined
                }
            ]
        });
        if (results[0].code) {
            formik.setFieldValue('is_automatic_stock', false);
            formik.setFieldValue('price_stock', results[0].full_discount);
            formik.setFieldValue('promo_code', null);
            formik.setFieldValue('stock_name', results[0].stock_name);
            formik.setFieldValue('stock', results[0].stock_id);
        } else {
            formik.setFieldValue('manual_stock', null);
            formik.setFieldValue('stock_name', null);
        }
        return results[0];
    } catch (e) {
        console.error(e);
        formik.setFieldValue('manual_stock', null);
        formik.setFieldValue('stock_name', null);
        formik.setFieldValue('stock', null);
        return {
            code: false
        };
    }
};

export const checkManualStockMulti = async (arr: IDateTimeOrdersState[], item: Record<string, any> | null, formik: any, currentUser: ICurrentUserState) => {
    try {
        const data = arr.map((item) => {
            if (item.data.rate && item.data.tariff) {
                return {
                    tariff_rate: item.data.rate.id.toString(),
                    price: currentUser.user_status === TYPE_USER.SUPERUSER ? Math.trunc(Number(item.data.rate.price)) : undefined,
                };
            }
            return { tariff_rate: '' }
        });
        const results = await checkManualStockStaff({
            user_id: formik.values.customer.value,
            stock_id: item ? item.value : undefined,
            data
        });
        if (!item) {
            formik.setFieldValue('price_stock', 0);
            formik.setFieldValue('stock', null);
            formik.setFieldValue('stock_name', null);
        }
        formik.setFieldValue('is_automatic_stock', false);
        formik.setFieldValue('price_stock', results.reduce(
            (previousValue: any, currentValue: any) => previousValue + currentValue.full_discount,
            0
        ));
        if (results[0].code) formik.setFieldValue('stock_name', results[0].stock_name);
        formik.setFieldValue('stock_name', null);
        formik.setFieldValue('promo_code', null);
        formik.setFieldValue('stock', results[0].stock_id);
        return results[0];
    } catch (e) {
        console.error(e);
        formik.setFieldValue('stock_name', null);
        formik.setFieldValue('manual_stock', null);
        return {
            code: false
        };
    }
};
export const checkAutomaticStockMulti = async (arr: IDateTimeOrdersState[], formik: any, side: number, customer: ICurrentUserState, setAutomaticFlag?: (e: boolean) => void) => {

    const data: TStockCheckDataSerializerStaff[] = arr.map((item) => {
        if (item.data.rate && item.data.tariff) {
            return {
                tariff_rate: item.data.rate.id.toString(),
                start_at: dayjs(`${item.date} ${item.time}`, 'YYYY.MM.DD HH:mm').subtract(3, 'h').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
                price: customer.user_status === TYPE_USER.SUPERUSER ? Math.trunc(Number(item.data.rate.price)) : undefined
            };
        }
        return { tariff_rate: '' }
    });
    try {
        const results = await api.tariff.checkAutomaticStock({
            user_id: formik.values.customer.value,
            stock_id: formik.values.stock ? formik.values.stock.id : undefined,
            data
        });
        if (setAutomaticFlag) setAutomaticFlag(results[0].code);
        if (results[0].code) formik.setFieldValue('stock_name', results[0].stock_name);
        formik.setFieldValue('manual_stock', null);
        formik.setFieldValue('price_stock', results.reduce(
            (previousValue: any, currentValue: any) => previousValue + currentValue.full_discount,
            0
        ));
        formik.setFieldValue('is_automatic_stock', results[0].code);
        formik.setFieldValue('promo_code', null);
        return results;
    } catch (e) {
        console.error(e);
        formik.setFieldValue('stock_name', null);
        if (setAutomaticFlag) setAutomaticFlag(false);
        return {
            code: false
        };
    }
};
export const checkPromoCodeMylti = (arr: IDateTimeOrdersState[], formik: any, currentUser: ICurrentUserState) => {

    try {
        const data = arr.map((item) => {
            if (item.data.rate && item.data.tariff) {
                return {
                    tariff_rate: item.data.rate.id.toString(),
                    start_at: dayjs(`${item.date} ${item.time}`, 'YYYY.MM.DD HH:mm').subtract(3, 'h').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
                    price: currentUser.user_status === TYPE_USER.SUPERUSER ? Math.trunc(Number(item.data.rate.price)) : undefined
                };
            }
            return { tariff_rate: '' }
        });
        const response = api.tariff.checkPromoCode({
            code: formik.values.promo_code,
            user_id: formik.values.customer.value,
            data
        });

        if (formik.values.promo_code === '') {
            toast.error(NAME_STATUS_API_ORDER.PROMOCODE.ERROR_NAME);
        } else if (formik.values.promo_code === null) {
            toast.error(NAME_STATUS_API_ORDER.PROMOCODE.ERROR_TARIFF);
        } else {
            toast.promise(
                response,
                {
                    pending: NAME_STATUS_API_ORDER.PROMOCODE.PENDING,
                    error: {
                        render(res: Record<string, any>) {
                            const {data, status} = res.data.response;
                            if (status === 500) {
                                toast.error(NAME_STATUS_API_ORDER.ACTIVATE_CERTIFICATE.ERROR_500);
                            }
                            if (Array.isArray(data)) {
                                data.forEach((item: string) => {
                                    toast.error(item);
                                });
                            } else {
                                objectKeys(data).forEach((key) => {
                                    toast.error(data[key][0]);
                                });
                            }

                            return NAME_STATUS_API_ORDER.PROMOCODE.ERROR_REQ
                        }
                    }
                }).then((results) => {
                if (results[0].code) {
                  formik.setFieldValue('stock_name', results[0].stock_name);
                  formik.setFieldValue('stock_name', null);
                }

                formik.setFieldValue('price_stock', results.reduce(
                    (previousValue, currentValue) => previousValue + currentValue.full_discount,
                    0
                ));
                formik.setFieldValue('is_automatic_stock', false);
                formik.setFieldValue('manual_stock', null);
                formik.setFieldValue('stock', results[0].stock_id);
            });
        }
    } catch (e) {
        formik.setFieldValue('stock_name', null);
        formik.setFieldValue('promo_code', null);
    }
};
// работа с промокодом
export const checkPromoCode = (formik: any, date: string | null | undefined, code: string | null, currentUser: ICurrentUserState) => {
    const response = api.tariff.checkPromoCode({
        code,
        user_id: formik.values.customer.value,
        data: [{
            tariff_rate: formik.values.tariff_rate.id,
            start_at: dayjs(date, 'YYYY.MM.DD HH:mm').subtract(3, 'h').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
            price: currentUser.user_status === TYPE_USER.SUPERUSER ? formik.values.base_price : undefined
        }]
    });

    if (code === '' || code === null) {
        toast.error(NAME_STATUS_API_ORDER.PROMOCODE.ERROR_NAME);
    } else {
        toast.promise(
            response,
            {
                pending: NAME_STATUS_API_ORDER.PROMOCODE.PENDING,
                error: {
                    render(res: Record<string, any>) {
                        const {data, status} = res.data.response;
                        if (status === 500) {
                            toast.error(NAME_STATUS_API_ORDER.ACTIVATE_CERTIFICATE.ERROR_500);
                        }
                        if (status === 404) {
                            toast.error(NAME_STATUS_API_ORDER.PROMOCODE.ERROR);
                        }
                        if (status === 400 && Array.isArray(data) && data[0] === 'Промо код был использован') {
                            return data[0];
                        }
                        return NAME_STATUS_API_ORDER.PROMOCODE.ERROR_REQ
                    }
                }
            }).then((results) => {
            if (results[0].code) {
                formik.setFieldValue('stock_name', results[0].stock_name);
                formik.setFieldValue('price_stock', results[0].full_discount);
                formik.setFieldValue('is_automatic_stock', false);
                formik.setFieldValue('manual_stock', null);
                formik.setFieldValue('stock', results[0].stock_id);
            }
            if (!results[0].code) {
                toast.error(NAME_STATUS_API_ORDER.PROMOCODE.ERROR);
                formik.setFieldValue('stock_name', null);
            }
        });
    }
    return response;
};

export const getArrParticipants = (array: TUserOrderParticipants[]): Array<{ id: number }> => {
    return array.map((item: Record<string, any>) => {
        return {
            id: item.value
        };
    });
};

export const checkUserStatus = (values: any, statusTransferOrder: boolean, typeOrder: ORDERS) => {
    let userType = '';
    let sportsmanFlag = false;
    let isSport = false
    if (values.customer) {
      const type = values.customer[TYPE_USER_SPORTSMAN[typeOrder]]
        isSport = values.customer[`${TYPE_USER_SPORTSMAN[typeOrder]}_is_sport`] || values.customer[TYPE_USER_SPORTSMAN[typeOrder]].is_sport
        if (statusTransferOrder || !type?.slug) {
            userType = type;
        } else {
            userType = type.slug;
        }
        sportsmanFlag = userType === 'sportsman';
    }
    return {userType, sportsmanFlag, isSport};
};

export const installRatesListWithData = (
  formik: any,
  statusTransferOrder: boolean,
  statusCreateMultiOrders: boolean,
  data: IRetrieveOrder,
  tariffs: Record<string, any>,
  typeOrder: number,
) => {
    const {userType, isSport} = checkUserStatus(data, statusTransferOrder, typeOrder);
    formik.setFieldValue('is_sport', isSport);

    const { tariff_rate } = data

    if (formik.touched?.customer) {
        if (!statusCreateMultiOrders && !statusTransferOrder && tariffs[userType] && tariff_rate) {
            const rates_list = rangeOptions(tariffs[userType].tariff_rates, formik.values.is_children, typeOrder);

            const isValueTariffRate = rates_list.find((elem) => elem.id === data?.tariff_rate?.id)

            formik.setFieldValue('tariff_rates', rates_list);
            formik.setFieldValue('base_price', isValueTariffRate ? tariff_rate.price : rates_list[0].price);
            formik.setFieldValue('price', isValueTariffRate ? tariff_rate.price : rates_list[0].price);
            formik.setFieldValue('user_type_slug', userType);
            formik.setFieldValue('tariff_rate', isValueTariffRate ? tariff_rate : rates_list[0]);
        }
    } else if (tariffs) {

        if (tariffs[userType]){
            const rates_list = rangeOptions(tariffs[userType].tariff_rates, formik.values.is_children, typeOrder);

            formik.setFieldValue('tariff_rates', rates_list);
        } else {
            const rates_list = rangeOptions(formik.values.tariff.tariff_rates, formik.values.is_children, typeOrder);

            formik.setFieldValue('tariff_rates', rates_list);
        }
    }

};

export const installRatesListByChildren = (
  formik: any,
  statusTransferOrder: boolean,
  statusCreateMultiOrders: boolean,
  data: IRetrieveOrder,
  tariffs: Record<string, ITariff | null>,
  typeOrder: number,
) => {
    const { userType, isSport } = checkUserStatus(data, statusTransferOrder, typeOrder);
    formik.setFieldValue('is_sport', isSport);
      const { is_children } = data
      const userTariff = tariffs[userType]
    if (!statusCreateMultiOrders && !statusTransferOrder && userTariff &&
      (formik.values.is_children !== is_children)) {
        const rates_list = rangeOptions(userTariff.tariff_rates, formik.values.is_children, typeOrder);
        // поиск детского или взрослого тарифа с теми же минутами
        if (rates_list.length !== 0) {
            const isTariffWithSameMinutes = rates_list.find(( elem ) => elem.minutes === formik.values.tariff_rate?.minutes);

            formik.setFieldValue('tariff_rates', rates_list);
            formik.setFieldValue('tariff_rate', isTariffWithSameMinutes || rates_list[0]);
            formik.setFieldValue('base_price', isTariffWithSameMinutes ? isTariffWithSameMinutes.price : rates_list[0].price);
            formik.setFieldValue('price', isTariffWithSameMinutes ? isTariffWithSameMinutes.price : rates_list[0].price);
            formik.setFieldValue('user_type_slug', userType);
        }
    }
};

export const installRatesList = (
    formik: any,
    statusTransferOrder: boolean,
    statusCreateMultiOrders: boolean,
    tariffs: Record<string, ITariff | null>,
    typeOrder: number,
    arrayDateTimeOrders: IDateTimeOrdersState[]
) => {
    const { userType, isSport } = checkUserStatus(formik.values, statusTransferOrder, typeOrder);
    formik.setFieldValue('is_sport', isSport);
    const userTariff = tariffs[userType]

    if (!statusCreateMultiOrders && !statusTransferOrder) {
        // Если есть тариф подходящий под выбронного контрагент. устанваливаем ставку, тариф и цену
        if (userTariff) {
            const rates_list = rangeOptions(userTariff.tariff_rates, formik.values.is_children, typeOrder);
            formik.setFieldValue('tariff', {
                value: userTariff.id,
                label: userTariff.title,
                ...userTariff
            });
            formik.setFieldValue('base_price', rates_list.length !== 0 ? rates_list[0].price : 0);
            formik.setFieldValue('tariff_rates', rates_list);
            formik.setFieldValue('tariff_rate', rates_list.length !== 0 ? rates_list[ 0 ] : {
                price: 0, strikeout_price: null, count_people: 0, minutes: 0
            });
            formik.setFieldValue('sessionTimeoutSecs', convertTimeToIntegerMinutes(userTariff.duration_check));
            formik.setFieldValue('stock', undefined);
        } else {
            formik.setFieldValue('base_price', 0);
            formik.setFieldValue('tariff_rates', []);
            formik.setFieldValue('stock', undefined);
            formik.setFieldValue('tariff', {value: null, label: null, tariff_rates: [], is_for_sportsman: false});
            formik.setFieldValue('tariff_rate', {
                price: 0, strikeout_price: null, count_people: 0, minutes: 0
            });
            formik.setFieldValue('sessionTimeoutSecs', 0);
        }
    }
    if (formik.values.customer && statusCreateMultiOrders && arrayDateTimeOrders.length === 0) {
        api.tariff.getRatesList({
            user_type: formik.values.customer[TYPE_USER_SPORTSMAN[typeOrder]].slug,
            is_child: formik.values.is_children,
            side: typeOrder,
        }).then((results) => {
            const rates = rangeMultiOrdersOptions(results, typeOrder);
            formik.setFieldValue('multiRates', rates);
            formik.setFieldValue('stock', undefined);
            formik.setFieldValue('tariff_rate_multi', results.length > 0 ? rates[0] : null);
            formik.setFieldValue('sessionTimeoutSecs', 60);
        });
    }
};

export const orderPriceInfo = (formik: FormikValues) => {
    return {
        base_price: Number(formik.values.base_price),
        price: Number(formik.values.price),
        price_stock: Number(formik.values.price_stock),
        price_paid: Number(formik.values.price_paid),
        price_total: Number(formik.values.base_price) - Number(formik.values.price_stock) - Number(formik.values.price_paid) >= 0 ? Number(formik.values.base_price) - Number(formik.values.price_stock) - Number(formik.values.price_paid) : 0
    };
};

export const infoPriceReturnPay = (data: Record<string, any> | number) => {
    if (typeof data === 'number') {
        return {
            price: 0,
            price_paid: 0,
            price_total: 0,
        };
    }
    return {
        price: Number(data.amount),
        price_paid: Number(data.price_paid),
        price_total: Number(data.amount) - Number(data.price_paid),
    };
};

export function contains(arr: Array<number>, elem: number) {
    for (let i = 0; i < arr.length; i += 1) {
        if (arr[i] === elem) {
            return true;
        }
    }
    return false;
}

export const getReturnableOrders = (orders: Array<Record<string, any>>) => {
    return orders.filter((item: Record<string, any>) => item.status !== TYPES_STATUS.CANCEL && item.status !== TYPES_STATUS.PAY_ERROR);
};

export const countReturnResurcePayment = (type: number, orders: Array<Record<string, any>>, ordersId: any) => {
    const returnableOrders = getReturnableOrders(orders);

    let amount = 0;
    let total_paid = 0;
    if (returnableOrders.length === 0) {
        return {total_paid, amount};
    }

    if (type === RETURN_PAY_TYPES.CERTIFICATE) {
        amount = returnableOrders.length > 1 ? returnableOrders.reduce(
            (previousValue: number, currentValue: Record<string, any>) => {
                if (contains(ordersId, currentValue.id)) {
                    return previousValue + Math.trunc(currentValue.side === ORDERS.PIPE ? currentValue.certificate_mins_paid : currentValue.certificate_sets_paid);
                }
                return previousValue;
            },0)
            : Math.trunc(returnableOrders[0].side === ORDERS.PIPE ? returnableOrders[0].certificate_mins_paid : returnableOrders[0].certificate_sets_paid);

    } else if (type === RETURN_PAY_TYPES.FROM_DEPOSIT_MINUTES) {
        amount = returnableOrders.length > 1 ? returnableOrders.reduce(
            (previousValue: number, currentValue: Record<string, any>) => {

                if (contains(ordersId, currentValue.id)) {
                    return previousValue + Math.trunc(currentValue.side === ORDERS.PIPE ? currentValue.deposit_mins_paid : currentValue.deposit_sets_paid);
                }
                return previousValue;
            },
            0)
            : Math.trunc(returnableOrders[0].side === ORDERS.PIPE ? returnableOrders[0].deposit_mins_paid : returnableOrders[0].deposit_sets_paid);
    } else {
        amount = returnableOrders.length > 1 ? returnableOrders.reduce(
            (previousValue: number, currentValue: Record<string, any>) => {
                if (contains(ordersId, currentValue.id)) {
                    return previousValue + Math.trunc(currentValue.price_paid);
                }
                return previousValue;
            },
            0
        ) : Math.trunc(returnableOrders[0].price_paid);
    }

    total_paid = returnableOrders.length > 1 ? returnableOrders.reduce(
        (previousValue: number, currentValue: Record<string, any>) => {
            if (contains(ordersId, currentValue.id)) {
                return previousValue + Math.trunc(currentValue.side === ORDERS.PIPE ? currentValue.tariff_rate.minutes : currentValue.tariff_rate.count_people);
            }
            return previousValue;
        },0)
        : Math.trunc(returnableOrders[0].side === ORDERS.PIPE ? returnableOrders[0].tariff_rate.minutes : returnableOrders[0].tariff_rate.count_people);
    return {total_paid, amount};
};

export const returnPaymentOrders = ({ ordersId, values }: IReturnOrders) => {

    const response = api.payment.returnPayment({
        order_id: ordersId,
        return_method: values.return_method,
        comment: values.comment
    });
    return toast.promise(
        response,
        {
            pending: NAME_STATUS_API_ORDER.RETURN_ORDERS.PENDING,
            error: {
                render(res: Record<string, any>) {
                    try {

                        const {data, status} = res.data.response;
                        if (status === 500 || status === 502 || status === 503) {
                            toast.error(NAME_STATUS_API_ORDER.RETURN_ORDERS.ERROR_500);
                        }
                        if (Array.isArray(data)) {
                            data.forEach((item: string) => {
                                toast.error(item);
                            });
                        } else {
                            Object.keys(data).forEach((key) => {
                                if (data[key] !== 'results') toast.error(data[key][0]);
                            });
                        }
                    } catch (e) {
                        console.error(e);
                    }
                    return NAME_STATUS_API_ORDER.RETURN_ORDERS.ERROR;
                }
            }
        });
};

export const countResurcePayment = (type: number, orders: Array<Record<string, any>>,formik:FormikValues) => {
    let amount = 0;

    if (type === PAYMENT_TYPE.CERTIFICATE) {
        amount =  orders.filter((order:Record<string, any>)=>order.flag).reduce(
            (previousValue: number, currentValue: Record<string, any>) => {
                    return previousValue + Number(currentValue.side === ORDERS.PIPE ? currentValue.tariff_rate.minutes : currentValue.tariff_rate.count_people) - Number(currentValue.side === ORDERS.PIPE ? currentValue.certificate_mins_paid : currentValue.certificate_sets_paid);

            },0)

    } else if (type === PAYMENT_TYPE.DEPOSITS && formik.values.deposit_type !== TYPES_DEPOSITS.MONEY) {
        amount =  orders.filter((order:Record<string, any>)=>order.flag).reduce(
            (previousValue: number, currentValue: Record<string, any>) => {
                    return previousValue + Number(currentValue.side === ORDERS.PIPE ? currentValue.tariff_rate.minutes : currentValue.tariff_rate.count_people) - Number(currentValue.side === ORDERS.PIPE ? currentValue.deposit_mins_paid : currentValue.deposit_sets_paid);
            },
            0)
    } else {
        amount = orders.filter((order:Record<string, any>)=>order.flag).reduce((previousValue: number, currentValue: Record<string, any>) => {
                    return previousValue + Number(currentValue.price) - Number(currentValue.price_paid);
            },
            0
        )
    }
    return {amount};
};

export const countPayment = (orders: Array<Record<string, any>>,type:any,formik: FormikValues) => {
    let total_paid = 0;
    let base_price = 0;
    let ordersList:any = orders.filter((item: Record<string, any>)=> item.flag);

    total_paid =  ordersList.reduce(
            (previousValue: number, currentValue: Record<string, any>) => {
                if (currentValue.certificate_name) {
                    return previousValue + Number(currentValue.side === ORDERS.PIPE ? currentValue.certificate_mins_paid : currentValue.certificate_sets_paid);
                }
                if(currentValue.deposit_mins_paid){
                    return previousValue + Number(currentValue.side === ORDERS.PIPE ? currentValue.deposit_mins_paid : currentValue.deposit_sets_paid);
                }
                    return previousValue + Number(currentValue.price_paid);
            },0)
        base_price =  ordersList.filter((item: Record<string, any>)=> item.flag).reduce(
            (previousValue: number, currentValue: Record<string, any>) => {
                if ((type === PAYMENT_TYPE.DEPOSITS && formik.values.deposit_type !== TYPES_DEPOSITS.MONEY)|| type === PAYMENT_TYPE.CERTIFICATE) {
                    return previousValue + Number(currentValue.side === ORDERS.PIPE ? currentValue.tariff_rate.minutes : currentValue.tariff_rate.count_people);
                }

                return previousValue + Number(currentValue.price);
            },0)

    return {total_paid,base_price};
};
